import React from "react";

const UdharChithi = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h2>UdharChithi</h2>
        <p>Content for UdharChithi page will go here.</p>
      </div>
    </div>
  );
};

export default UdharChithi;
